export const common = {
  // Navigation
  "nav.home": "Inicio",
  "nav.features": "Características",
  "nav.benefits": "Beneficios",
  "nav.contact": "Contacto",
  "nav.language": "Idioma",
  
  // Hero Section
  "hero.title": "GPAX: Plataforma que permite auditoría digital",
  "hero.subtitle": "Escriba su plan anual, realice auditorías, supervise el trabajo, gestione informes. Proporcione a sus equipos de auditoría y administrativos una herramienta que apoye el seguimiento de los hallazgos de los informes.",
  "hero.cta": "Comenzar Ahora",
  "hero.demo": "Ver Demo",
  
  // Features
  "features.centralized": "Centralizado",
  "features.secure": "Seguro",
  "features.realtime": "En tiempo real",
  
  // Modules
  "modules.title": "Módulos de GPAX Audit",
  "modules.risk": "Riesgo",
  "modules.planning": "Planificación",
  "modules.execution": "Ejecución",
  "modules.communication": "Comunicación",
  
  // Risk Module
  "risk.title": "GPAX Audit proporciona una herramienta que le permite gestionar sus riesgos, medir la efectividad de los controles y asegurar que las actividades de control se lleven a cabo.",
  "risk.feature1": "Priorizar actividades basadas en la evaluación de riesgos del Universo Auditable.",
  "risk.feature2": "Evaluación de riesgos de los procesos ejecutados por la empresa u organización.",
  "risk.feature3": "Gestión y evaluación del riesgo operacional a través de la entrada de la matriz de riesgo SARO, detallando factores de riesgo, eventos y actividades de control.",
  "risk.feature4": "Personalización de escalas, pesos, valores, etc., completamente configurable.",
  
  // Planning Module
  "planning.title": "GPAX Audit le permite definir los procesos, actividades, documentos y detalles que serán evaluados durante el plan anual, basado en estándares, especificaciones, normatividad, leyes o regulaciones.",
  "planning.feature1": "Administración del plan estratégico institucional.",
  "planning.feature2": "Preparación del plan anual basado en riesgo, priorizando las evaluaciones según su riesgo.",
  "planning.feature3": "Alineación de los objetivos estratégicos con objetivos del plan anual de auditoría.",
  "planning.feature4": "Administración y control de asignación de recursos humanos, presupuestos y recursos financieros reales.",
  "planning.feature5": "Control de la fecha de inicio y fin de cada auditoría, comparado con la fecha real de inicio y fin.",
  
  // Execution Module
  "execution.title": "GPAX Audit permite ejecutar procedimientos, revisar y analizar evidencia, generar el archivo digital de cada auditoría.",
  "execution.feature1": "Administración y control de asignaciones de personal en tiempo real.",
  "execution.feature2": "Supervisión y autorización de la planificación y programa de trabajo de cada asignación en tiempo real.",
  "execution.feature3": "Digitalización de papeles de trabajo de cada procedimiento realizado por los auditores.",
  "execution.feature4": "Supervisión en tiempo real para la ejecución efectiva del trabajo, cumpliendo con programas de aseguramiento de calidad y mejora continua.",
  "execution.feature5": "Supervisión y control de recursos asignados, tanto financieros como el tiempo real invertido en los procedimientos de cada trabajo.",
  "execution.feature6": "Alarmas, notificaciones, indicadores de progreso y estadísticas comparativas.",
  
  // Communication Module
  "communication.title": "GPAX Audit incluye un canal de comunicación recíproca que permite tanto al auditor como a los auditados gestionar sus hallazgos y planes de acción.",
  "communication.feature1": "Administración y control de los informes generados para cada trabajo.",
  "communication.feature2": "Control en conjunto con la administración para la revisión y seguimiento de recomendaciones y cumplimiento de planes de acción.",
  "communication.feature3": "Control automatizado a través de alarmas y notificaciones de vencimiento de hallazgos y planes de acción.",
  "communication.feature4": "Registro en tiempo real de evidencia de cumplimiento satisfactorio de planes de acción.",
  "communication.feature5": "Control a través de Kanban de hallazgos, planes de acción pendientes y/o vencidos.",
  
  // Benefits
  "benefits.title": "Beneficios Clave",
  "benefits.reduce": "Reduce 50%",
  "benefits.reduce.desc": "Reduce el tiempo de documentación hasta en un 50%, generando información valiosa.",
  "benefits.cost": "Hasta 90%",
  "benefits.cost.desc": "Hasta 90% de reducción en costos operativos.",
  "benefits.affordable": "Costo asequible",
  "benefits.affordable.desc": "Costo asequible, gran flexibilidad e implementación rápida.",
  "benefits.improves": "Mejora hasta 40%",
  "benefits.improves.desc": "Mejora hasta un 40% la productividad y ejecución de los proyectos.",
  
  // Other Features
  "other.title": "Otras características",
  "other.feature1": "Base de conocimiento: Administración de capital humano y estándares de calidad.",
  "other.feature2": "Alertas, tableros, indicadores e informes.",
  "other.feature3": "Multiidioma.",
  "other.feature4": "Sistema de correo para enviar notificaciones.",
  "other.feature5": "Seguridad tipo banca por internet.",
  "other.feature6": "Autenticación con cuentas de Microsoft.",
  
  // Advantages
  "advantages.title": "Ventajas",
  "advantages.subtitle": "Acceso garantizado a indicadores clave en tiempo real.",
  "advantages.feature1": "Gestión del plan estratégico y operacional.",
  "advantages.feature2": "Ejecución de proyectos usando Gantt.",
  "advantages.feature3": "Generación de alertas e indicadores.",
  "advantages.feature4": "Chat en línea para trabajo en equipo.",
  "advantages.feature5": "Control de recursos y trabajo realizado.",
  "advantages.feature6": "Tableros de control.",
  
  // Success Stories
  "success.title": "Casos de éxito",
  "success.auditing": "Organizaciones de auditoría",
  "success.auditing.desc": "200 auditores coordinados, realizando su trabajo en línea, con supervisión proactiva y obteniendo resultados en tiempo real.",
  "success.financial": "Entidad financiera",
  "success.financial.desc": "Auditoría completamente gestionada, permitiendo que los auditados también tengan una herramienta para monitorear sus temas pendientes.",
  "success.municipality": "Municipalidad",
  "success.municipality.desc": "Control de documentación y gestión de flujo de revisión, gestión centralizada de quejas y reclamos.",
  
  // CTA
  "cta.title": "¿Quiere saber más sobre nosotros?",
  "cta.button": "Contáctanos",
  
  // Footer
  "footer.contact": "Contacto",
  "footer.phone": "+506 2447 9912",
  "footer.email": "soluciones@infowarecr.com",
  "footer.talk": "Hablar con nosotros",
  "footer.terms": "Términos y Servicios",
  "footer.privacy": "Privacidad",
  "footer.sla": "SLA"
};

export default common;